import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { loadInvoiceCheck } from 'actions/appointments';
import SingleTextLoader from 'organisms/Loaders/SingleTextLoader';
import { isEmpty, isNotEmptyArray } from 'util';

export default function ServiceSummary({ selectedServiceUuid }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    dispatch(loadInvoiceCheck(selectedServiceUuid)).then(
      ({ success, data }) => {
        if (success) setInvoice(data?.data?.invoice);
        setIsLoading(false);
      }
    );
  }, [selectedServiceUuid]);

  return !isEmpty(invoice) ? (
    <div className="service-summary-panel flex-column mb-12 p-24 border-light-purple radius-24">
      <h4 className="mb-12">Service summary</h4>
      {isNotEmptyArray(invoice?.transaction?.details) &&
        invoice.transaction.details.map((item) => (
          <div
            className="flex-row justify-between mb-12 f13"
            key={item.description}
          >
            <p>{item.description}</p>
            <p>{item.price?.localized}</p>
          </div>
        ))}

      <div className="flex-row justify-between f16 pt-15 border-top-light-purple pt-12">
        <p className="bold">Total</p>
        {isLoading ? (
          <SingleTextLoader />
        ) : (
          <p className="bold">{invoice?.total?.localized}</p>
        )}
      </div>
    </div>
  ) : null;
}
